<template>
  <div v-if="projects.length || !isIncomingProjects" class="sidebar-projects-list">
    <router-link
      :to="{ name: isIncomingProjects ? 'incoming-projects' : 'projects' }"
      class="sidebar-link current w-inline-block"
    >
      <div class="caps">
        {{ isIncomingProjects ? $t('Incoming tenders') : $t('Projects') }}
      </div>
      <RoundedPlusIcon
        v-if="canI('createProjects') && !isIncomingProjects"
        fill="#45484C"
        @click="newProject"
      />
    </router-link>

    <div v-for="proj in projects" :key="proj.id" class="d-contents">
      <a
        v-if="proj.status !== 'declined'"
        class="sidebar-link sub-link w-inline-block spacex-8"
        @click.prevent="openProj(proj)"
      >
        <FireIcon v-if="isFireAlertProject(proj)" />
        <div
          v-else
          class="project-color"
          :style="{ 'background-color': projectColor(proj) || DEFAULT_COLOR }"
        />
        <div class="sidebar-projects-name">
          {{ isIncomingProjects ? proj.tender.name : proj.name }}
        </div>
        <NewAlert v-if="isFireAlertProject(proj)" class="fw-5" />
      </a>
    </div>
  </div>
</template>

<script>
  import RoundedPlusIcon from '@/assets/icons/rounded-plus.svg';
  import { mapActions } from 'vuex';
  import AddProjectModal from '@/containers/projects/AddModal';
  import canI from '@/utils/roles/access';
  import FireIcon from '@/assets/icons/fire.svg';
  import NewAlert from '@/components/common/NewAlert';
  import { DEFAULT_COLOR } from '@/utils/constants/common';
  import get from 'lodash.get';
  import getProjectLink from '@/utils/mixins/get-project-link';

  export default {
    name: 'SidebarProjectsList',
    components: {
      NewAlert,
      RoundedPlusIcon,
      FireIcon,
    },
    mixins: [getProjectLink],
    props: {
      projects: {
        type: Array,
        default: () => [],
      },
      isIncomingProjects: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        DEFAULT_COLOR,
      };
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
      }),
      canI,
      isFireAlertProject(proj) {
        return this.isIncomingProjects && proj.status === 'invited';
      },
      newProject() {
        this.openModal({
          component: AddProjectModal,
          context: {
            attributes: {
              class: 'new-project-modal',
            },
          },
        });
      },
      openProj(proj) {
        if (this.isIncomingProjects) {
          this.$router.push({
            name: 'incoming-tender-summary',
            params: { incomingTenderId: proj.id },
          });
        } else {
          this.$router.push(this.getProjectLink(proj));
        }
      },
      projectColor(proj) {
        return get(proj, this.isIncomingProjects ? 'tender.project.color' : 'color', DEFAULT_COLOR);
      },
    },
  };
</script>
<style scoped>
  .project-color {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    border-radius: 4px;
  }
  .sidebar-link {
    display: flex;
    min-height: 28px;
    margin: 8px 0;
    padding: 6px 8px;
    align-items: center;
    transition: all 200ms ease;
    color: rgba(4, 8, 14, 1);
    text-decoration: none;
    cursor: pointer;
  }

  .sidebar-link .caps {
    font-family: noto-sans, sans-serif;
    flex: 1;
    font-size: 14px;
    line-height: 20px;
    color: #7e8186;
  }

  .sidebar-link.sub-link {
    border-radius: 8px;
    padding: 6px 8px;
  }

  .sidebar-link.sub-link:hover {
    background-color: #f3f6fb;
  }
</style>
